/*خرده فروشی*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={84.879}
      height={91.729}
      viewBox="0 0 84.879 91.729"
      {...props}
    >
      <path
        data-name="Path 7565"
        d="M4.768 83.536H80.11v6.849H4.768z"
        fill="#5f99d7"
      />
      <path
        data-name="Path 7566"
        d="M4.768 83.537h8.958v6.849H4.768z"
        fill="#3c87d0"
      />
      <path
        data-name="Path 7567"
        d="M11.618 1.34h61.644v13.7H11.618z"
        fill="#5f99d7"
      />
      <path
        data-name="Path 7568"
        d="M11.617 1.344h8.958v13.7h-8.958z"
        fill="#3c87d0"
      />
      <path
        data-name="Path 7569"
        d="M21.892 28.742H11.618l7.705-13.7h7.705z"
        fill="#eaf6ff"
      />
      <path
        data-name="Path 7570"
        d="M42.44 28.742H32.166l2.568-13.7h7.705z"
        fill="#eaf6ff"
      />
      <path
        data-name="Path 7571"
        d="M62.987 28.742H52.714l-2.568-13.7h7.706z"
        fill="#eaf6ff"
      />
      <path
        data-name="Path 7572"
        d="M83.532 28.742H73.261l-7.705-13.7h7.705z"
        fill="#eaf6ff"
      />
      <path
        data-name="Path 7573"
        d="M11.618 28.742h61.644v54.794H11.618z"
        fill="#8ac9fe"
      />
      <path
        data-name="Path 7574"
        d="M11.617 28.741h5.375v54.8h-5.375z"
        fill="#60b7ff"
      />
      <path
        data-name="Path 7575"
        d="M16.756 39.018a5.137 5.137 0 01-5.137-5.137v-5.137h10.273v5.137a5.137 5.137 0 01-5.136 5.137z"
        fill="#eaf6ff"
      />
      <path
        data-name="Path 7576"
        d="M57.851 39.018a5.137 5.137 0 01-5.137-5.137v-5.137h10.274v5.137a5.137 5.137 0 01-5.137 5.137z"
        fill="#eaf6ff"
      />
      <path
        data-name="Path 7577"
        d="M37.303 39.018a5.137 5.137 0 01-5.137-5.137v-5.137H42.44v5.137a5.137 5.137 0 01-5.137 5.137z"
        fill="#eaf6ff"
      />
      <g data-name="Group 353" fill="#f07281">
        <path
          data-name="Path 7578"
          d="M11.618 28.742H1.344l10.274-13.7h7.709z"
        />
        <path
          data-name="Path 7579"
          d="M32.166 28.742H21.892l5.137-13.7h7.705z"
        />
        <path data-name="Path 7580" d="M52.714 28.742H42.442v-13.7h7.7z" />
        <path
          data-name="Path 7581"
          d="M73.262 28.742H62.988l-5.137-13.7h7.705z"
        />
        <path
          data-name="Path 7582"
          d="M6.481 39.018a5.137 5.137 0 01-5.137-5.137v-5.137h10.274v5.137a5.137 5.137 0 01-5.137 5.137z"
        />
        <path
          data-name="Path 7583"
          d="M27.029 39.018a5.137 5.137 0 01-5.137-5.137v-5.137h10.274v5.137a5.137 5.137 0 01-5.137 5.137z"
        />
        <path
          data-name="Path 7584"
          d="M47.577 39.018a5.137 5.137 0 01-5.134-5.139v-5.137h10.274v5.137a5.137 5.137 0 01-5.14 5.139z"
        />
        <path
          data-name="Path 7585"
          d="M68.125 39.018a5.137 5.137 0 01-5.137-5.137v-5.137h10.274v5.137a5.137 5.137 0 01-5.137 5.137z"
        />
      </g>
      <path
        data-name="Path 7586"
        d="M78.398 39.018a5.137 5.137 0 01-5.137-5.137v-5.137h10.274v5.137a5.137 5.137 0 01-5.137 5.137z"
        fill="#eaf6ff"
      />
      <path
        data-name="Path 7587"
        d="M18.467 46.182h20.548v37.354H18.467z"
        fill="#eaf6ff"
      />
      <path
        data-name="Path 7588"
        d="M18.466 46.182h5.375v37.355h-5.375z"
        fill="#d8ecfe"
      />
      <path
        data-name="Path 7589"
        d="M45.864 46.182h20.548v17.044H45.864z"
        fill="#eaf6ff"
      />
      <path
        data-name="Path 7590"
        d="M45.863 46.182h5.375v17.043h-5.375z"
        fill="#d8ecfe"
      />
      <path
        data-name="Path 7591"
        d="M45.864 63.223h20.548v6.612H45.864z"
        fill="#5f99d7"
      />
      <path
        data-name="Path 7592"
        d="M45.863 63.226h5.375v6.613h-5.375z"
        fill="#3c87d0"
      />
      <g data-name="Group 354">
        <path
          data-name="Path 7593"
          d="M84.874 28.643a1.363 1.363 0 00-.264-.707l-10-13.339V1.344A1.344 1.344 0 0073.262 0H59.494a1.344 1.344 0 000 2.687h12.425V13.7H12.961V2.687h40.678a1.344 1.344 0 000-2.687H11.617a1.344 1.344 0 00-1.344 1.344V14.6l-10 13.339a1.365 1.365 0 00-.269.806v5.137a6.558 6.558 0 0010.269 5.246v43.064h-5.5a1.344 1.344 0 00-1.344 1.344v6.849a1.344 1.344 0 001.344 1.344h75.338a1.344 1.344 0 001.344-1.344v-6.849a1.344 1.344 0 00-1.344-1.344h-5.5V65.917a1.344 1.344 0 00-2.687 0v16.275H40.359v-36.01a1.344 1.344 0 00-1.344-1.344H28.558a1.344 1.344 0 000 2.687h9.114v34.667H19.81V47.526h2.892a1.344 1.344 0 100-2.687h-4.236a1.344 1.344 0 00-1.344 1.344v36.01h-4.161V39.127a6.657 6.657 0 008.931-1.3 6.534 6.534 0 0010.274 0 6.534 6.534 0 0010.274 0 6.534 6.534 0 0010.274 0 6.534 6.534 0 0010.274 0 6.657 6.657 0 008.931 1.3V60.06a1.344 1.344 0 102.687 0V39.128a6.574 6.574 0 0010.277-5.249v-5.137c0-.034 0-.066-.005-.1zm-6.107 60.4H6.112V84.88h72.655zM53.828 27.4l-2.064-11.01h5.155l4.129 11.01zm-30 0l4.129-11.01h5.155L31.051 27.4zm9.954 0l2.064-11.01h5.247V27.4zm10 0V16.387h5.247L51.094 27.4zM25.09 16.387L20.961 27.4h-7.045l6.193-11.01zM63.918 27.4l-4.129-11.01h4.981l6.194 11.01zm10.129 0l-6.193-11.013h4.736L80.848 27.4zM12.29 16.387h4.736L10.832 27.4h-6.8zM6.483 37.672a3.8 3.8 0 01-3.8-3.793v-3.794h7.59V33.9a3.8 3.8 0 01-3.79 3.772zm14.067-3.793a3.793 3.793 0 11-7.587 0v-3.794h7.587zm10.274 0a3.793 3.793 0 11-7.587 0v-3.794h7.587zm10.274 0a3.793 3.793 0 11-7.587 0v-3.794h7.587zm6.481 3.793a3.8 3.8 0 01-3.796-3.793v-3.794h7.587v3.8a3.8 3.8 0 01-3.793 3.787zm14.067-3.793a3.793 3.793 0 01-7.587 0v-3.8h7.587zm10.274 0a3.793 3.793 0 11-7.587 0v-3.794h7.587zm10.274 0a3.793 3.793 0 01-7.586.017v-3.811h7.586z"
        />
        <path
          data-name="Path 7594"
          d="M45.864 44.838a1.344 1.344 0 00-1.344 1.344v23.655a1.344 1.344 0 001.344 1.344h20.543a1.344 1.344 0 001.344-1.344V46.182a1.344 1.344 0 00-1.344-1.344zm1.344 2.687h17.86v14.357H47.207zm17.86 20.968H47.207v-3.925h17.86z"
        />
        <path
          data-name="Path 7595"
          d="M23.973 66.413v6.849a1.344 1.344 0 002.687 0v-6.849a1.344 1.344 0 00-2.687 0z"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
